// extracted by css-extract-rspack-plugin
export default {"cls1":"mentions_milestone_ping-cls1_haX","cls2":"mentions_milestone_ping-cls2_D9s mentions_milestone_ping-cls1_haX"};